import React, { Component } from 'react'
import PropTypes from 'prop-types'
import pluralize from 'pluralize'
import classnames from 'classnames/bind'
import { Text } from '@adc/ui-adc'
import { formatLocation } from '../../converters/location'
import NearbyCheckbox from '../nearbyCheckbox'
import { checkIsNearbySearch } from '../../util/nearbyCheckbox'
import { getPropertyTotalAmount } from '../../util/asset'
import styles from './styles.scss'
const cx = classnames.bind(styles)

class AssetTotals extends Component {
  static propTypes = {
    filters: PropTypes.object.isRequired,
    assets: PropTypes.object.isRequired,
    elmId: PropTypes.string.isRequired,
    updateFiltersAction: PropTypes.func.isRequired,
  }

  renderNearLocation = () => {
    const { filters, assets, elmId } = this.props
    const { city, zip, county, useNearbySearch } = filters
    const isNearbySearch = checkIsNearbySearch(city, zip, county)
    const locationOutput = {}
    if (filters.globalSearch === 'y') {
      return ''
    } else if (filters.search) {
      locationOutput.prefix = 'related to '
      locationOutput.value = filters.search
    } else if (
      useNearbySearch === 'y' &&
      isNearbySearch &&
      assets.offset >= assets.nearbyTotal
    ) {
      locationOutput.prefix = 'near '
      locationOutput.value = formatLocation(filters)
    } else {
      const formattedLocation = formatLocation(filters)
      locationOutput.prefix = formattedLocation ? 'in ' : ''
      locationOutput.value = formattedLocation
    }
    return (
      <span>
        {locationOutput.prefix}
        {locationOutput.value && (
          <span data-elm-id={`${elmId}_in_location`}>
            {locationOutput.value}
          </span>
        )}
      </span>
    )
  }

  render() {
    const { assets, filters, elmId, updateFiltersAction } = this.props
    const { total, fetchProgress, nearbyTotal = 0, offset } = assets
    const nearLocation = this.renderNearLocation()
    const nearbyPropertyTotal =
      nearbyTotal > offset ? nearbyTotal : total - nearbyTotal
    const propertyTotal = getPropertyTotalAmount(
      { total, nearbyTotal: nearbyPropertyTotal },
      filters.globalSearch
    )

    return (
      <div className={cx('u-ml-3')} data-elm-id={elmId}>
        <div className={cx('asset-totals')}>
          <Text.Header
            as='h1'
            className={cx('description', 'u-mb-1')}
            data-elm-id={`${elmId}_label`}
            color='gray'
            size='huge'
          >
            {fetchProgress.loading ? (
              '- Properties'
            ) : (
              <>
                <span data-elm-id={`${elmId}_in_count`}>
                  {propertyTotal.toLocaleString('en')}
                </span>
                {` ${pluralize('Property', propertyTotal)} `}
                {nearLocation}
              </>
            )}
          </Text.Header>
          <NearbyCheckbox
            filters={filters}
            assets={assets}
            elmId={elmId}
            updateFiltersAction={updateFiltersAction}
          />
        </div>
      </div>
    )
  }
}

export default AssetTotals
